// React
import React, { useState, useEffect } from "react";
// React
// CSS
import styles from "./Step3.module.css";
// CSS
// Services
import { getCities_Service } from "../../../Services/Common/getCities_Service";
import { getGrades_Service } from "../../../Services/Common/getGrades_Service";
// Services
// Models
import {
  I_City,
  I_Grade,
  I_UserStep3OTPData,
} from "../../../Models/interfaces";
// Models
// Utils
import SelectOptionBuilder from "../../../Utils/SelectOptionBuilder/SelectOptionBuilder";
import { useNavigate } from "react-router-dom";
import { _axios } from "../../../Utils/Axios/axios";
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
// Utils

type Step3Props = {
  formStep: number;
  userPhoneNumber: number;
  isRegisterNeed: boolean;
};

const Step3: React.FunctionComponent<Step3Props> = ({
  formStep,
  userPhoneNumber,
  isRegisterNeed,
}) => {
  // ************************************************** States
  const [userImg, setUserImg] = useState<File>();
  //
  const [grades, setGrades] = useState<I_Grade[]>([]);
  //
  const [cities, setCities] = useState<I_City[]>([]);
  //
  const [userData, setUserData] = useState<
    I_UserStep3OTPData & {
      cityName: string;
    }
  >({
    name: "",
    gradeId: 1,
    cityId: 1,
    cityName: "لطفا شهر را انتخاب کنید",
  });
  // ************************************************** States
  /********************************************************** */
  /********************************************************** */
  // ************************************************** Constants
  const navigate = useNavigate();
  // ************************************************** Constants
  /********************************************************** */
  /********************************************************** */
  // ************************************************** Life Cycles
  useEffect(() => {
    !isRegisterNeed && navigate("/");
  }, [isRegisterNeed, navigate]);
  //
  useEffect(() => {
    if (formStep === 3) {
      getGrades_Service()
        .then(({ data: { data } }) => {
          setGrades(data);
        })
        .catch((err) => {
          console.log(err);
          toast(
            err.response.data.message ? err.response.data.message : err.message
          );
        });
      getCities_Service()
        .then(({ data: { data } }) => {
          setCities(data);
        })
        .catch((err) => {
          console.log(err);
          toast(
            err.response.data.message ? err.response.data.message : err.message
          );
        });
    }
  }, [formStep]);
  //
  // useEffect(() => {
  //   console.log(userData);
  // }, [userData]);
  // ************************************************** Life Cycles

  return (
    <>
      <div
        className={`${styles.step3Container} w-full h-full top-0 left-0 absolute bg-white flex items-center justify-center`}
      >
        {/* Waves */}
        <div
          className={`${styles.wave} ${styles.topWave} absolute top-0 left-0`}
        ></div>
        <div
          className={`${styles.wave} ${styles.bottomWave} absolute bottom-0 left-0`}
        ></div>
        {/* Waves */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}

        <div className={`${styles.innerContent} w-full px-4`}>
          <HelperHeader absoluteText="خــوش آمــدید" isBgWhite={true} />
          <div
            className={`${styles.imageContainer} flex items-center justify-center mt-4 rounded-full`}
          >
            <img
              src={userImg !== undefined ? URL.createObjectURL(userImg) : ""}
              alt=""
              className="w-20 h-20 rounded-full p-0.5"
              onClick={() => {
                const imgInput = document.getElementById("imgInput");
                if (!imgInput) return;
                // console.log(imgInput);
                imgInput.click();
              }}
            />
            <input
              type="file"
              className="hidden "
              id="imgInput"
              multiple={false}
              onChange={(e: React.FormEvent<HTMLInputElement>) => {
                if (!e.currentTarget.files) return;
                setUserImg(e.currentTarget.files[0]);
              }}
            />
          </div>
          <p className="text-center my-2">{userPhoneNumber}</p>
          <input
            type="text"
            className="w-full rounded-lg py-1.5 dark:!text-black"
            placeholder="نام و نام خانوادگی"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (!e.currentTarget.value) return;
              setUserData((prevState) => ({
                ...prevState,
                name: e.target.value,
              }));
            }}
          />
          <SelectOptionBuilder
            dataForBuildOptions={grades}
            initialShowName="مقطع را انتخاب کنید"
            onClick={(gradeId) => {
              // console.log(gradeId);
              setUserData((prevState) => ({ ...prevState, gradeId }));
            }}
          />
          <SelectOptionBuilder
            dataForBuildOptions={cities.map((item) => ({
              title: item.name,
              id: item.id,
            }))}
            initialShowName={`${userData.cityName}`}
            onClick={(cityId) => {
              // console.log(cityId);
              setUserData((prevState) => ({
                ...prevState,
                cityId,
                cityName: cities.filter(
                  (item) => String(item.id) === String(cityId)
                )[0].name,
              }));
            }}
          />
          <div className={`${styles.citiesOptionsContainer}`}></div>
          <button
            className={`${styles.submitBtn} text-white w-full text-center mt-4 rounded-lg py-2`}
            onClick={() => {
              const { cityId, gradeId, name } = userData;
              if (cityId !== "" && gradeId !== "" && name !== "") {
                _axios
                  .post(
                    "/register",
                    {
                      phone: userPhoneNumber,
                      grade_id: gradeId,
                      city_id: cityId,
                    },
                    {}
                  )
                  .then(({ data, status }) => {
                    if (status === 200 || 201) {
                      // console.log(data);
                      navigate("/");
                    } else {
                      throw new Error("Error");
                    }
                  })
                  .catch((err: any) => {
                    console.log(err);
                    Swal.fire({
                      icon: "error",
                      title: err.response.data.message,
                    });
                  });
              }
            }}
          >
            تایید و ذخیره
          </button>
        </div>
      </div>
    </>
  );
};

export default Step3;
